exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container {\n  display: -ms-flexbox;\n  display: flex;\n  height: 15%;\n  background-color: #007BB9; }\n\n.unit-header-container {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%; }\n\n.unit-header-container:not(:last-child):after {\n  content: '|';\n  color: #fff;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.header-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/header-toolbar/header-toolbar.component.scss
// module id = ../../../../../src/app/core/components/header-toolbar/header-toolbar.component.scss
// module chunks = main